export default {
  init() {

  },

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};
